module.exports = __webpack_public_path__ + "img/loader-telechargement.bc90ec9e.gif";